import React from 'react';
import { Sun, Moon } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';

/**
 * Dark/light switch.
 *
 * variant="icon"  — bare icon button, for dense chrome like the sidebar footer
 * variant="pill"  — labelled control, for settings-style rows
 */
export default function ThemeToggle({ variant = 'icon', size = 13, style, className }) {
  const { isDark, toggleTheme } = useTheme();
  const label = isDark ? 'Switch to light mode' : 'Switch to dark mode';
  const Icon = isDark ? Sun : Moon;

  if (variant === 'pill') {
    return (
      <button type="button" onClick={toggleTheme} title={label} aria-label={label}
        className={className || 'btn btn-ghost btn-sm'} style={style}>
        <Icon size={size} /> {isDark ? 'Light mode' : 'Dark mode'}
      </button>
    );
  }

  return (
    <button type="button" onClick={toggleTheme} title={label} aria-label={label}
      className={className || 'btn-icon'} style={style}>
      <Icon size={size} />
    </button>
  );
}
